/*
 * @Author: cn1994
 * @Date: 2023-01-18 16:55:51
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-02 15:33:03
 * @Description: 示例页面路由
 */

const routes = [
  {
    path: '/examples/valgusAngle',
    name: 'examples_valgusAngle',
    component: () => import('../pages/examples/valgusAngle.vue'),
  },
  {
    path: '/examples/useAudioRegions',
    name: 'examples_useAudioRegions',
    component: () => import('../pages/examples/useAudioRegions.vue'),
  },
  {
    path: '/examples/tailwind',
    name: 'examples_tailwind',
    component: () => import('../pages/examples/tailwind.vue'),
  },
  {
    path: '/examples/tracking',
    name: 'examples_tracking',
    meta: {
      title: '埋点示例'
    },
    component: () => import('../pages/examples/tracking.vue'),
  },
  {
    path: '/examples/pinia',
    name: 'examples_pinia',
    meta: {
      title: 'pinia示例'
    },
    component: () => import('../pages/examples/pinia.vue'),
  },
  {
    path: '/examples/dialog',
    name: 'examples_dialog',
    meta: {
      title: 'dialog示例'
    },
    component: () => import('../pages/examples/dialog.vue'),
  },
  {
    path: '/examples/text',
    name: 'examples_text',
    meta: {
      title: 'text示例'
    },
    component: () => import('../pages/examples/text.vue'),
  },
  {
    path: '/examples/tag',
    name: 'examples_tag',
    meta: {
      title: 'tag示例'
    },
    component: () => import('../pages/examples/tag.vue'),
  },
]

export default routes
